// Reporta al servicio LTI que el alumno completo la actividad. El servicio
// LTI a su vez notifica a Moodle via AGS para actualizar el gradebook.
//
// Idempotente por thread_id (el conversation_id del frontend): si ya se
// reporto exito antes, no vuelve a llamar al backend. Esto cubre recargas
// con `currentPhase === 'feedback'` y `feedbackMessage` ya en localStorage.
//
// Fire-and-forget desde la UI: si falla no debe bloquear la pantalla de
// feedback. Tras un POST exitoso, ademas, emite un CustomEvent global por
// si en el futuro queremos enganchar un toast "Actividad registrada".

import { getSessionToken } from './ltiSession';

export const COMPLETION_REPORTED_EVENT = 'lti:completion-reported';

const COMPLETED_FLAG_PREFIX = 'lti_completed_';

const LTI_SERVICE = process.env.REACT_APP_LTI_SERVICE_URL;

const completedFlagKey = (conversationId) => `${COMPLETED_FLAG_PREFIX}${conversationId}`;

export function isCompletionAlreadyReported(conversationId) {
    if (!conversationId) return false;
    try {
        return !!window.localStorage.getItem(completedFlagKey(conversationId));
    } catch (_) {
        return false;
    }
}

export async function reportCompletion() {
    let conversationId = null;
    try {
        conversationId = window.localStorage.getItem('thread_id');
    } catch (_) {}

    if (!conversationId) {
        console.warn('[LTI] No conversation_id (thread_id), cannot report completion');
        return;
    }

    if (isCompletionAlreadyReported(conversationId)) {
        console.info('[LTI] Completion already reported for this conversation');
        return;
    }

    const token = getSessionToken();
    if (!token) {
        console.warn('[LTI] No session token, cannot report completion');
        return;
    }

    if (!LTI_SERVICE) {
        console.warn('[LTI] REACT_APP_LTI_SERVICE_URL not configured, skipping completion report');
        return;
    }

    try {
        const response = await fetch(`${LTI_SERVICE}/api/complete`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({ conversation_id: conversationId }),
        });

        if (response.ok) {
            try {
                window.localStorage.setItem(completedFlagKey(conversationId), new Date().toISOString());
            } catch (_) {}
            console.info('[LTI] Completion reported successfully');
            try {
                window.dispatchEvent(new CustomEvent(COMPLETION_REPORTED_EVENT, {
                    detail: { conversationId },
                }));
            } catch (_) {}
        } else {
            console.error('[LTI] Failed to report completion:', response.status);
        }
    } catch (error) {
        console.error('[LTI] Error reporting completion:', error);
    }
}
